export default __webpack_public_path__ + "static/media/site-operator-preamble.6a007d81.md";